import SeoLinks from '@bridebook/web/app-basic/components/seo-links/seo-links';
import { memo } from 'react';
import { ILocationData } from '@bridebook/web/app-shared/lib/search/types';
import { SearchType } from '@bridebook/toolbox/src/search-suppliers/types';

interface IProps {
  data?: ILocationData | null;
  prettyCategory: string;
  relatedAreas?: string[];
}

const InfoWrapper = ({ data, prettyCategory, relatedAreas }: IProps) => {
  const related = relatedAreas || data?.related || [];
  const showRelated = related.length && data?.index;

  if (!data || !showRelated) {
    return null;
  }

  const location =
    data.type === SearchType.County ? data.county || data.country : data.town || data.name;

  return showRelated ? (
    <div className="bsinfo">
      <div className="bsinfo-container">
        <div className="bsinfo-content">
          {showRelated && (
            <SeoLinks
              prettyCategory={prettyCategory}
              locations={related}
              location={location}
              locationType={data.type}
              topBorder={false}
            />
          )}
        </div>
      </div>
    </div>
  ) : null;
};

export default memo(InfoWrapper);
